import styled from 'styled-components';

const StyledPanelHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 20px;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-weight: 600;
	color: #e6e6e6;
	user-select: none;
`;

export { StyledPanelHeader };
